import PropTypes from 'prop-types';
import CheckboxElement from '../../CheckboxElement';
import { CurrentDataProvider } from '../../../currentDataCtx';

function CheckboxCellEditor(props) {
  const { value, onValueChange, data, context, componentProps } = props;
  // eslint-disable-next-line no-unused-vars
  const { valueType, ...restComponentProps } = componentProps || {};
  return (
    <CurrentDataProvider value={data}>
      <CheckboxElement
        className="table-checkbox-editor"
        suppressFormControl={true}
        value={value}
        onChange={onValueChange}
        componentProps={{
          size: context.tableSize,
          ...restComponentProps,
        }}
      />
    </CurrentDataProvider>
  );
}

CheckboxCellEditor.propTypes = {
  value: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.number, PropTypes.string])),
    PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string,
        value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      }),
    ),
  ]),
  onValueChange: PropTypes.func,
  data: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }),
  context: PropTypes.shape({
    tableSize: PropTypes.oneOf(['default', 'small']),
  }),
  componentProps: PropTypes.shape({}),
};

export default CheckboxCellEditor;
